angular.module('twaCommonComponents', []);
var twaCC = angular.module('twaCommonComponents');